/** Filters provider plans by the active plan category (route query or prop). */
export const planCategoryFilterMixin = {
	computed: {
		normalizedPlanCategoryId() {
			const fromProp = this.planCategoryId;
			const fromRoute = this.$route && this.$route.query ? this.$route.query.planCategoryId : null;
			const raw = fromProp !== null && fromProp !== '' && typeof fromProp !== 'undefined'
				? fromProp
				: fromRoute;
			if (raw === null || raw === '' || typeof raw === 'undefined') {
				return null;
			}
			const value = Number(raw);
			return Number.isNaN(value) ? null : value;
		},
	},
	methods: {
		matchesPlanCategory(plan) {
			if (this.normalizedPlanCategoryId === null) {
				return true;
			}
			const raw = plan.planCategoryId !== undefined && plan.planCategoryId !== null
				? plan.planCategoryId
				: plan.PlanCategoryId;
			if (raw === '' || raw === undefined || raw === null) {
				return false;
			}
			const id = Number(raw);
			return !Number.isNaN(id) && id === this.normalizedPlanCategoryId;
		},
		filterPlansByCategory(plans) {
			if (!Array.isArray(plans)) {
				return [];
			}
			if (this.normalizedPlanCategoryId === null) {
				return plans;
			}
			return plans.filter(plan => this.matchesPlanCategory(plan));
		},
	},
};
